var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Table',{attrs:{"loading":_vm.loading,"data":_vm.tableData,"height":500,"columns":_vm.columns}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }